<template>
  <div class="order-page">
    <!-- <el-card class="box-card">
    </el-card>
    <el-card class="button-box">
      <el-row></el-row>
    </el-card>-->
    <el-card class="box-card">
      <!-- el-form -->

      <el-form :model="form"
               label-width="50px"
               style="width: 100%">
        <el-row>
          <el-col :span="6">
            <el-form-item prop="type"
                          label="报表">
              <el-select clearable
                         v-model="form.type"
                         placeholder="请选择报表...">
                <el-option v-for="item in type_list"
                           :key="item.value"
                           :label="item.name"
                           :value="item.value">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <el-row :gutter="20">
        <el-col>
          <el-button type="primary"
                     :loading="loading"
                     @click="handleClick">搜索</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- el-table -->
    <el-table max-height="1100"
              :data="tableData"
              v-loading="loading">
      <el-table-column prop="reportname"
                       align="center"
                       header-align="center"
                       label="报表类型"></el-table-column>
      <el-table-column prop="file_name"
                       align="center"
                       header-align="center"
                       label="文件名"
                       width="260px"
                       show-overflow-tooltip>
        <!-- <template slot-scope="scope">
          <el-row>
            <el-col>{{scope.row.file_name}}</el-col>
            <el-col>{{scope.row.input_file_name}}</el-col>
          </el-row>
        </template>-->
      </el-table-column>

      <el-table-column prop="create_user"
                       align="center"
                       header-align="center"
                       label="操作人"></el-table-column>
      <el-table-column prop="action_type"
                       align="center"
                       header-align="center"
                       label="操作类型"></el-table-column>
      <el-table-column prop="create_time"
                       align="center"
                       header-align="center"
                       label="操作时间"></el-table-column>
      <el-table-column prop="action_result"
                       align="center"
                       header-align="center"
                       label="操作结果"
                       width="90px"
                       show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag v-if="scope.row.process_status === 1"
                  type="success">{{ scope.row.action_result }}</el-tag>
          <span class="danger"
                v-else-if="scope.row.process_status === 4"
                type="danger">{{ scope.row.action_result }}</span>
          <el-tag v-else>{{ scope.row.action_result }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="remark"
                       align="center"
                       header-align="center"
                       label="备注"></el-table-column>

      <el-table-column align="center"
                       header-align="center"
                       label="操作">
        <template slot-scope="scope">
          <el-tooltip content="下载"
                      placement="top">

            <el-button v-if="scope.row.action_type === 'download' && scope.row.process_status === 1"
                       type="text"
                       icon="el-icon-download"
                       @click="download(scope.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
  </div>
</template>

<script>
import RfmMixin from '@/common/mixins/rfmlog-mixin'
// import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
const tempPrefixeUrl = 'http://test.databankapi.transecs.com/'
export default {
  mixins: [RfmMixin],
  data() {
    return {
      form: { type: '' },
      loading: false,
      searchLoading: false,
      tableData: [],
      Desc,
      reportTypeList: [],
      queryPrdlists: {
        param: ['report_type'],
        query: {
          report_type: null,
        },
        pagenum: 1,
        pagesize: 10,
      },
      download_url: 'http://test.databankapi.transecs.com',
      type_list: [
        { name: '销售额单月', value: 1 },
        { name: '顾客继续新规', value: 2 },
        { name: '顾客Recency&运转率', value: 3 },
        { name: '顾客F×M累计', value: 4 },
        { name: '顾客level报表', value: 5 },
        { name: '顾客继续-既存', value: 6 },
        { name: '顾客继续-整体', value: 7 },
        { name: '销售额移动和', value: 8 },
        { name: '顾客存活', value: 9 },
        { name: '顾客FM累计-12个月', value: 10 },
        { name: '商品-新客', value: 11 },
        { name: '商品-交叉营销', value: 12 },
        { name: '商品-继续', value: 13 },
      ],
    }
  },
  created() {
    // this.getTableData();
    // this.getOperatelogReporttype()
  },
  methods: {
    download(row) {
      // let url = tempPrefixeUrl + row.file_path
      let url = this.download_url + row.file_path
      console.log('url', url)
      window.open(url, '_blank')
      console.log(`文件地址：${row.file_path}`)

      // alert(`文件地址：${file_path}`);
    },
    handleClick() {
      if (!this.form.type) {
        this.$message.error('请选择报表类型')
        return
      }
      console.log(this.form.type)

      this.queryPrdlists.query.report_type = this.form.type
      // console.log(this.queryPrdlists);
      // this.loading = true
      this.getTableData()
      // this.loading = false
    },
    resetForm() {
      this.form = { type: '' }
    },
    async getTableData() {
      this.loading = true
      let { data, err } = await this.axiosApi(Desc.list_api, this.queryPrdlists)
      // console.log("data", data);
      this.loading = false
      this.tableData = data.data.data.data
      if (data && data.data.data.path) {
        this.download_url = data.data.data.path.split('/api')[0]
      } else {
        console.log('else')
        this.download_url = empPrefixeUrl
      }
      this.total = parseInt(data.data.data.total)
      dealReturn(data, err)
    },
    async getOperatelogReporttype() {
      // this.loading = true

      let { data, err } = await this.axiosApi(Desc.type_api)
      // console.log("data", data);
      // this.tableData = data.data.data.data
      // this.total = parseInt(data.data.data.total)
      this.reportTypeList = data.data.data
      console.log(data.data.data)
      // console.log(data)
      // dealReturn(data, err)
    },
  },
}
</script>

<style lang="less" scoped>
.danger {
  background-color: #fef0f0;
  border-color: #f56c6c;
  color: #f56c6c;
  // padding: 12px 1px 4px 8px;
  // border-width: 1px;
  // border-style: solid;
  // border-radius: 4px;
  // -webkit-box-sizing: border-box;
  // box-sizing: border-box;
  // white-space: nowrap;
  // display: inline-block;
  display: block;
  height: 32px;
  padding: 0 10px;
  line-height: 30px;
  font-size: 12px;
  // color: #409eff;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 24px;
  padding: 0 8px;
  line-height: 22px;
  width: 80px;
}
</style>


// WEBPACK FOOTER //
// src/views/rfm/rfmlog/index.vue